import { Link } from 'react-router-dom';
import { Page } from '../shell/AppShell';
import { EmptyState, Panel } from '../ui/primitives';

export function NotFound() {
  return (
    <Page title="Not found">
      <Panel>
        <EmptyState
          title="There is no screen at this address"
          detail={
            <>
              Every screen the ERP has is in the command palette (⌘K). <Link className="text-brand underline" to="/overview">Go to the Control Center</Link>.
            </>
          }
        />
      </Panel>
    </Page>
  );
}
